/**
 * Le garanzie che il sito espone come etichette brevi.
 *
 * Una lista sola perché le superfici sono due — la sezione «Sicurezza e
 * riservatezza» in home e il piè di pagina di ogni pagina — e finché erano
 * due liste separate dicevano cose diverse: la home prometteva quattro cose,
 * il footer quattro altre, e nessuna delle due era il set completo. Chi legge
 * l'una e poi l'altra non deve chiedersi quale valga.
 *
 * Non stanno in `content/landing`, che è dichiaratamente la homepage: il
 * footer è di tutte le pagine.
 *
 * ⚠️ «Conforme all'AI Act» è una dichiarazione di conformità, non una
 * descrizione: va pubblicata solo se esiste una verifica interna degli
 * obblighi oggi applicabili — divieti dell'art. 5 e alfabetizzazione
 * dell'art. 4 (in vigore dal 2 febbraio 2025), trasparenza dell'art. 50
 * (applicabile dal 2 agosto 2026). Non esiste una certificazione AI Act
 * ottenibile per un sistema come Trovanorma: la valutazione di conformità con
 * marcatura CE riguarda i sistemi ad alto rischio, il cui regime è stato
 * rinviato al 2 dicembre 2027 dal Regolamento (UE) 2026/1744. Senza quella
 * verifica, togliere la riga.
 */
export const TRUST_BADGES = [
  'GDPR compliant',
  'Conforme all’AI Act',
  'Dati conservati in UE',
  'Cifratura in transito e a riposo',
  'Nessun training sui tuoi contenuti',
];
